import { useContext } from 'react';
import DateFormatContext from '../date-format-context';

export default () => useContext(DateFormatContext);
